<template>
  <!--购物车页面-->
  <tk-container
    :status="status"
    :probeType="3"
    infiniteScroll
    class="shopping-cart-bg"
    :style="{backgroundImage:` url(${themeImage}) !important`}"
    @scroll="watchScroll"
    @refresh="resetRefreshInit"
    ref="resetInfiniteScrollCar"
    @loadingMore="recommendedProducts"
  >
    <!--头部-->
    <gradient-header slot="header" :z-index="zIndex" :is-show-back="false" :is-header-color="isHeaderColor" :back-style="false" :icon-name="'return'">
      <div slot="center-menu"
           :style="{ color: isHeaderColor ? '#000000' : '#fff' + '!important', zIndex: zIndex }">购物车</div>
      <div slot="right-menu"
           style="margin-right: -13px;"
           v-if="shoppingCart.length">
        <action-button
          @click.native="performEditor"
          class="m-x-15" is-border
          :btn-text="toggleEditor ? '完成' : '编辑'"
          :bd-color="'rgba(255, 255, 255, 0)'" :text-color="isHeaderColor ? '#000000' : '#fff'"
          :min-width="54" :height="35" is-raised is-rounded
        ></action-button>
      </div>
    </gradient-header>
    <!--后台数据渲染-->
    <div class="content-box">
      <!--购物车数据-->
      <template v-if="shoppingCart.length">
        <div class="m-x-12">
          <card
            :width="100" :height="100"
            class="m-y-10 p-x-12"
            style="padding-top: 8px;padding-bottom: 8px;"
            v-for="(s, index) in shoppingCart"
            :key="`dataRound${index}`"
          >
            <!--商家名字-->
            <tk-flex middle style="font-size: 15px;" @click.native="selDataRound(s)">
              <tkui-toggle
                style="height: 16px;line-height: 16px;"
                v-model="s.dataRound"
                type="round"></tkui-toggle>
              <div class="m-l-12" style="line-height: 1;">{{merchantsName(s.merchants)}}</div>
            </tk-flex>
            <!--商品列表-->
            <tk-flex
              middle
              :class="{ 'p-t-8': index === 0, 'm-t-8': index > 0 }"
              between
              v-for="(m, index) in s.commodityData"
              :key="`commodityRound${index}`"
              @click.native.stop="$push({path: '/commodity/productDetails', query: { id: m.objectId }})"
            >
              <tk-flex middle @click.native.stop="selCommodityRound(s)">
                <tkui-toggle class="m-b-2" v-model="m.commodityRound" type="round"></tkui-toggle>
                <div
                  class="m-l-10 commodity-style-image"
                  @click.stop="$push({path: '/commodity/productDetails', query: { id: m.objectId }})"
                >
                  <tk-image :src="m.showPictures[0]" :width="85" :height="85"></tk-image>
                </div>
              </tk-flex>
              <tk-flex class="m-l-10 tk-grid-7" column>
                <div class="class-card-wrap font-14 van-multi-ellipsis--l2">{{m.productTitle}}</div>
                <div style="height: 20px;"></div>
                <tk-flex between middle class="full-width">
                  <div class="commodity-style-price m-t-15"><span class="font-12">￥</span>{{m.price}}</div>
                  <!--计数-->
                  <tk-flex class="m-t-15 selected-style-count">
                    <div
                      class="selected-style-count-left"
                      @click.stop="countLess(m)"
                    >
                      <tk-icon size="15" :color="m.numberOrders === 1 ? '#CACACA' : '#666666'" material>remove</tk-icon>
                    </div>
                    <tkui-simple-input
                      type="number"
                      :disabled="true"
                      class="selected-style-count-center"
                      v-model="m.numberOrders"
                      mask="natural"
                    >
                    </tkui-simple-input>
                    <div class="selected-style-count-right" @click.stop="countAdd(m)">
                      <tk-icon size="15" :color="m.numberOrders === m.inventory ? '#CACACA' : '#666666'" material>add</tk-icon>
                    </div>
                  </tk-flex>
                </tk-flex>
              </tk-flex>
            </tk-flex>
          </card>
        </div>
      </template>
      <!--失效数据-->
      <template v-if="invalidArr.length">
        <div class="m-x-15">
          <card
            :width="100" :height="150"
            class="m-y-10"
          >
            <!--card标题-->
            <tk-flex
              between
              middle
              class="full-width p-b-15"
            >
              <div class="font-bold">失效商品 {{invalidArr.length}} 件</div>
              <div class="font-14 font-bold primary" @click="emptyCommodity">清空失效商品</div>
            </tk-flex>
            <!--失效商品-->
            <tk-flex
              middle
              class="m-t-20"
              between
              v-for="(m, index) in invalidArr"
              :key="`invalid-arr${index}`"
            >
              <tk-flex middle>
                <tkui-toggle class="m-b-2 selected-style-filter" disabled type="round"></tkui-toggle>
                <div class="m-l-10 commodity-style-image selected-style-filter">
                  <tk-image :src="m.showPictures[0]" :width="85" :height="85"></tk-image>
                  <div class="commodity-style-image-invalid">已失效</div>
                </div>
              </tk-flex>
              <tk-flex class="m-l-10 tk-grid-7" column>
                <div class="caption class-card-wrap font-bold font-16 van-multi-ellipsis--l2">{{m.productTitle}}</div>
                <div style="height: 20px;"></div>
                <div class="font-12">此商品已不能购买</div>
              </tk-flex>
            </tk-flex>
          </card>
        </div>
      </template>
      <!--购物车无数据时-->
      <div v-else-if="!shoppingCart.length && !invalidArr.length" class="m-x-15">
        <card :width="100" :height="150">
          <empty-tips :height="150" :width="100" :empty-msg="'暂无数据'"></empty-tips>
        </card>
      </div>
      <!--猜你喜欢-->
      <infinite-list :title="'猜你喜欢'" :infinite-list-pad="'p-x-12'" :products-data="getPriceProcessing(recommendedProductsData, judgeTimeRule)" :color="'#000000'"></infinite-list>
    </div>
    <!--去结算底部栏-->
    <footer slot="footer" class="shopping-footer" v-if="shoppingCart.length">
      <tk-flex between middle class="m-x-12">
        <!--全选-->
        <tk-flex middle @click.native="selAllRound">
          <tkui-toggle class="m-b-2" v-model="allRound" type="round"></tkui-toggle>
          <div class="m-l-12 font-13" style="color: #666;">全选</div>
        </tk-flex>
        <!--总计与删除-->
        <tk-flex middle class="p-y-5">
          <div v-if="!toggleEditor" class="m-r-10">
            <span class="font-13">合计：</span>
            <span class="commodity-style-price font-18"><span class="font-10">￥</span>{{settlementAmount}}</span>
          </div>
          <tkui-button :disabled="deleteDisabled" @click="deleteCommodity" v-if="toggleEditor" class="small primary rounded raised settlement-btn">删除</tkui-button>
          <tkui-button @click="settlementOrder" v-else class="small primary rounded raised settlement-btn">去结算{{'(' + settlementNum + ')'}}</tkui-button>
        </tk-flex>
      </tk-flex>
    </footer>
    <!--去结算的弹框-->
    <tk-cover
      :hideOnClick="false"
      :show.sync="selectedShow"
      bottom
      transition
    >
      <div class="selected-card">
        <!--标题-->
        <tk-flex style="line-height: 1;" class="card-title p-x-12 p-b-8">
          <div class="tk-grid-3"></div>
          <div class="text-center tk-grid-6 font-14">所选商品需要分开结算</div>
          <div class="tk-grid-3 text-right p-r-2" @click="selectedShow = false">
            <tk-icon size="13" color="#999">guanbi</tk-icon>
          </div>
        </tk-flex>
        <!--列表-->
        <div class="cover-scroll-y">
          <div
            class="m-x-12"
            v-for="(s, index) in selectedProductsData"
            :key="index"
          >
            <linear-card
              :width="100"
              :height="95"
              :class="{ 'm-t-8': index > 0 }"
              class="p-y-8 p-x-12"
              :title="merchantsName(s.merchants) "
              :font-size="14"
              :is-more="false"
              :copy-title="`共${s.commodityData.length}件商品`"
              :linear-top-color="'rgba(255, 255, 255, 0)'"
              :linear-bottom-color="'rgba(255, 255, 255, 0)'"
            >
              <tk-flex
                class="cover-scroll-x p-t-8"
                style="width: 100%;"
                v-if="s.commodityData.length"
              >
                <tk-flex
                  :class="{ 'm-l-5': index > 0 }"
                  v-for="(s, index) in s.commodityData"
                  :key="`cover-image${index}`"
                >
                  <tk-flex middle center class="cover-image">
                    <tk-image :src="s.showPictures[0]" :width="95" :height="95"></tk-image>
                  </tk-flex>
                </tk-flex>
              </tk-flex>
              <tk-flex middle between class="p-t-4">
                <div class="font-14 p-t-4">
                  小计：<span class="primary font-16"><span class="font-10">￥</span>{{s.subtotal}}</span>
                </div>
                <tkui-button @click="settlementSingle(s)" class="small primary rounded raised settlement-btn">结算</tkui-button>
              </tk-flex>
            </linear-card>
          </div>
          <div style="height: 8px;"></div>
        </div>
      </div>
    </tk-cover>
  </tk-container>
</template>

<script>
import { floatingPoint, priceProcessing } from '@/assets/help/tool'
import LinearCard from '@/components/linearCard'
export default {
  components: {
    LinearCard
  },
  data () {
    return {
      status: 'loading', // 页面状态
      zIndex: 100, // 头部层
      themeImage: 'https://s3.moke.cloud/dianpei/f09ff3ec-1232-4ac0-b076-37f640e6b351.png', // 主题背景图片
      isHeaderColor: false, // 判断头部颜色切换
      deleteDisabled: false, // 删除按钮状态
      selectedShow: false, // 是否限时选择结算的商品弹框
      shoppingCart: [], // 购物车数据
      shoppingCartId: null, // 购物车Id
      invalidArr: [], // 购物车中的失效数据
      shoppingCartInvalid: [], //
      recommendedProductsData: [], // 猜你喜欢商品数据获取
      allProductsData: [], // 购物车中所有商品的数据
      selectedProductsData: [], // 选定的数据
      selectedMiddleData: [], // 选定的中间处理商品数据
      toggleEditor: false, // 编辑状态
      timeRule: null, // 限时抢购时间
      allRound: false // 全选状态
    }
  },
  computed: {
    // 判断抢购时间是否有效
    judgeTimeRule () {
      if (!this.timeRule) return false
      let endSum = new Date(this.timeRule.endTime).getTime()
      let nowSum = new Date().getTime()
      return nowSum - endSum < 0
    },
    // 计算选择结算的商品总额
    settlementAmount () {
      let sum = 0
      this.selectedProductsData.forEach(s => {
        let subtotal = 0
        if (!s.commodityData) { s.commodityData = [] }
        s.commodityData.forEach(s => {
          sum = floatingPoint(sum, floatingPoint(s.price, s.numberOrders, 'multiply'), 'add')
          subtotal = floatingPoint(subtotal, floatingPoint(s.price, s.numberOrders, 'multiply'), 'add')
        })
        s.subtotal = subtotal
      })
      return sum
    },
    // 计算选择结算的商品数量
    settlementNum () {
      let num = 0
      this.selectedProductsData.forEach(s => {
        num += s.commodityData.length
      })
      return num
    }
  },
  activated () {
    this.$store.commit('setSelectedData', [])
    this.setStatusBar('light')
    if (this.isHeaderColor) {
      this.setStatusBar('dark')
    }
    this.refreshInit()
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    next(true)
  },
  methods: {
    /**
    * 初始化数据
    * @date: 2020/4/1
    */
    async getInit () {
      try {
        await this.getShoppingCart() // 获取购物车数据
        await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
        this.$store.commit('setShoppingSum', this.shoppingCartNum())
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 获取购物车数据
     * @date: 2020/4/1
     */
    async getShoppingCart () {
      let shoppingCart = await this.$tkParse.getList('/classes/shoppingCart', {
        params: {
          limit: 1,
          where: {
            user: this.userInfo.objectId
          }
        }
      })
      if (shoppingCart.length) {
        shoppingCart = this.$tkHelper.deepClone(shoppingCart)
        let shoppingData = await this.handleShoppingCart(shoppingCart[0])
        await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
        shoppingData.forEach(s => {
          if (s.commodityData.length) {
            s.commodityData = priceProcessing(s.commodityData, this.judgeTimeRule)
          }
        })
        this.shoppingCart = shoppingData
        this.shoppingCartId = shoppingCart[0].objectId
      } else {
        this.shoppingCart = []
      }
    },
    // 加入购物车的商品数量
    shoppingCartNum () {
      if (!this.shoppingCart.length && !this.invalidArr.length) { return 0 }
      let sum = 0
      this.shoppingCart.forEach(s => {
        if (!s.commodityData) { s.commodityData = [] }
        sum += s.commodityData.length
      })
      return sum + this.invalidArr.length
    },
    /**
    * 处理购物车数据
    * @date: 2020/4/3
    */
    async handleShoppingCart (shoppingCart) {
      this.invalidArr = []
      if (!shoppingCart.data || (shoppingCart.data && !shoppingCart.data.length)) { return [] }
      let shoppingCartData = shoppingCart.data
      let arr = []
      let arrIndex = []
      let batchArr = []
      // shoppingCartData.forEach((s, sIndex) => {
      //   s.dataRound = false
      //   if (!s.commodityData) { s.commodityData = [] }
      //   if (s.commodityData.length) {
      //     s.commodityData.forEach((m, mIndex) => {
      //       m.commodityRound = false
      //       m.sIndex = sIndex
      //       m.mIndex = mIndex
      //       m.merchantsObj = s.merchants
      //       arr.push(m)
      //       let batch = this.$tkParse.batch.get(`/classes/commodity`, { params: { where: { objectId: m.objectId } } })
      //       batchArr.push(batch)
      //     })
      //   }
      // })
      for (let i = 0; i < shoppingCartData.length; i++) {
        let s = shoppingCartData[i]
        s.dataRound = false
        if (!s.commodityData) { s.commodityData = [] }
        if (s.commodityData.length) {
          for (let j = 0; j < s.commodityData.length; j++) {
            let m = s.commodityData[j]
            m.commodityRound = false
            m.sIndex = i
            m.mIndex = j
            m.merchantsObj = s.merchants
            arr.push(m)
            let batch = await this.$tkParse.get(`/classes/commodity`, { params: { where: { objectId: m.objectId } } })
            batchArr.push(batch)
          }
        }
      }
      if (!batchArr.length) { return [] }
      // let res = await this.$tkParse.batch.run()
      let res = batchArr
      // 找到失效的商品
      res.forEach((s, index) => {
        if (s.data.results.length && s.data.results[0].shelvesStatus === 'beenOffShelves') { arrIndex.push(index) }
        if (!s.data.results.length) { arrIndex.push(index) }
        // 修改商品属性
        let m = arr[index]
        if (s.data.results.length && shoppingCartData[m.sIndex].commodityData.length) {
          s.data.results[0].commodityRound = false
          s.data.results[0].sIndex = m.sIndex
          s.data.results[0].mIndex = m.mIndex
          s.data.results[0].merchantsObj = m.merchantsObj
          s.data.results[0].numberOrders = m.numberOrders
          shoppingCartData[m.sIndex].commodityData[m.mIndex] = s.data.results[0]
        }
      })
      arr.forEach((s, index) => {
        arrIndex.forEach(m => {
          if (index === m) {
            this.invalidArr.push(s)
          }
        })
      })
      // 从购物车数据中去掉失效的商品
      let shoppingCartInvalid = []
      for (let i = this.invalidArr.length - 1; i >= 0; i--) {
        // 去掉失效商品
        let s = this.invalidArr[i]
        shoppingCartData[s.sIndex].commodityData.splice(s.mIndex, 1)
        if (!shoppingCartData[s.sIndex].commodityData.length) { shoppingCartData.splice(s.sIndex, 1) }
        // 整理失效商品数据
        let index = shoppingCartInvalid.findIndex(m => { return s.merchantsObj.objectId === m.merchants.objectId })
        if (index === -1) {
          shoppingCartInvalid.push({ merchants: s.merchantsObj, commodityData: [s] })
        } else {
          shoppingCartInvalid[index].commodityData.push(s)
        }
      }
      this.shoppingCartInvalid = shoppingCartInvalid
      // 保存所有商品的数据allProductsData
      shoppingCartData.forEach((s, sIndex) => {
        s.sIndex = sIndex
        if (!s.commodityData) { s.commodityData = [] }
        s.commodityData.forEach((m, mIndex) => {
          m.mIndex = mIndex
          this.allProductsData.push(m)
        })
      })
      return shoppingCartData
    },
    /**
     * 限时抢购时间获取
     * @date: 2020/3/20
     */
    async getLimitedTimeRule () {
      let isoStartDate = new Date().toISOString()
      let startTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/startTime').catch(e => {
        return { data: null }
      })
      let endTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/endTime').catch(e => {
        return { data: null }
      })
      // 判断时间是否存在
      if (!startTime.data || !endTime.data) {
        this.timeRule = null
        return
      }
      let startSum = new Date(startTime.data).getTime()
      let nowSum = new Date(isoStartDate).getTime()
      if (nowSum <= startSum) {
        this.timeRule = null
        return
      }
      this.timeRule = {
        startTime: startTime.data,
        endTime: endTime.data
      }
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      if (this.isHeaderColor) {
        this.setStatusBar('dark')
      } else {
        this.setStatusBar('light')
      }
      this.$forceUpdate()
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async resetRefreshInit () {
      Object.assign(this.$data, this.$options.data())
      this.recommendedProductsData = []
      await this.getInit()
      this.$refs.resetInfiniteScrollCar.resetInfiniteScroll()
    },
    async refreshInit () {
      this.status = 'loading'
      Object.assign(this.$data, this.$options.data())
      await this.getInit()
      if (!this.recommendedProductsData.length) {
        this.$refs.resetInfiniteScrollCar.resetInfiniteScroll()
      }
    },
    /**
     * 为你推荐数据获取
     * @date: 2020/4/1
     */
    async recommendedProducts (page, next) {
      let commodityData = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 10,
          skip: page * 10,
          order: '-sales',
          where: {
            shelvesStatus: 'shelves'
          }
        }
      })
      this.recommendedProductsData = [...this.recommendedProductsData, ...commodityData]
      if (commodityData.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    },
    /**
     * 工具转换
     * @date: 2020/4/10
     */
    getPriceProcessing (arr, rule) {
      return priceProcessing(arr, rule)
    },
    /**
    * 商家名字
    * @date: 2020/4/1
    */
    merchantsName (merchants) {
      if (merchants.accountCategory === 'countyAccount') {
        return `${merchants.name}`
      }
      if (merchants.accountCategory === 'factoryAccount') {
        return merchants.brandName ? `${merchants.brandName}` : `厂家`
      }
    },
    /**
     * 减法计数
     * @date: 2020/3/27
     */
    countLess (m) {
      if (m.numberOrders <= 1) { return }
      m.numberOrders--
    },
    /**
     * 加法计数
     * @date: 2020/3/27
     */
    countAdd (m) {
      if (m.numberOrders > m.inventory) { return }
      m.numberOrders++
    },
    /**
    * 执行编辑
    * @date: 2020/4/1
    */
    async performEditor () {
      this.toggleEditor = !this.toggleEditor
      // 重新获取数据
      this.allProductsData = []
      this.selectedProductsData = []
      this.selectedMiddleData = []
      // numberOrders
      let oldCartArr = this.$tkHelper.deepClone(this.shoppingCart)
      await this.$tkParse.put(`/classes/shoppingCart/${this.shoppingCartId}`, {
        data: oldCartArr
      })
      await this.getShoppingCart() // 获取购物车数据
      await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
      this.$store.commit('setShoppingSum', this.shoppingCartNum())
      this.allRound = false
    },
    /**
    * toggle按商家选择处理allProductsData selectedProductsData
    * @date: 2020/4/2
    */
    selDataRound (s) {
      this.selectedProductsData = []
      this.selectedMiddleData = []
      if (!s.dataRound) {
        if (!s.commodityData) { s.commodityData = [] }
        s.commodityData.forEach(m => {
          m.commodityRound = false
        })
      }
      this.shoppingCart.forEach(s => {
        if (s.dataRound) {
          if (!s.commodityData) { s.commodityData = [] }
          this.selectedProductsData.push(s)
          if (!s.commodityData) { s.commodityData = [] }
          s.commodityData.forEach(m => {
            m.commodityRound = s.dataRound
            if (m.commodityRound) { this.selectedMiddleData.push(m) }
          })
        }
      })
      this.allRound = this.selectedMiddleData.length === this.allProductsData.length
      this.$forceUpdate()
    },
    /**
    * toggle按商品选择处理
    * @date: 2020/4/2
    */
    selCommodityRound (s) {
      let arr = []
      this.selectedMiddleData = []
      let newSelectedMiddleData = []
      this.selectedProductsData = []
      if (!s.commodityData) { s.commodityData = [] }
      s.commodityData.forEach(m => {
        if (m.commodityRound) { arr.push(m) }
      })
      s.dataRound = arr.length === s.commodityData.length
      this.shoppingCart.forEach(s => {
        if (!s.commodityData) { s.commodityData = [] }
        s.commodityData.forEach(m => {
          if (m.commodityRound) {
            this.selectedMiddleData.push(m)
            newSelectedMiddleData.push({ merchants: s.merchants, commodity: m })
          }
        })
      })
      this.allRound = this.selectedMiddleData.length === this.allProductsData.length
      // 选择的商品按商家归类
      let obj = {}
      newSelectedMiddleData.forEach(s => {
        let attr = s.merchants.objectId
        if (obj[attr]) { obj[attr].push(s) } else { obj[attr] = [s] }
      })
      for (let i in obj) {
        let s = obj[i]
        this.selectedProductsData.push({ merchants: s[0].merchants, commodityData: s.map(m => { return m.commodity }) })
      }
    },
    /**
    * toggle全部选择处理
    * @date: 2020/4/2
    */
    selAllRound () {
      this.selectedMiddleData = []
      this.selectedProductsData = []
      this.shoppingCart.forEach(s => {
        s.dataRound = this.allRound
        if (s.dataRound) { this.selectedProductsData.push(s) } else { this.selectedProductsData = [] }
        if (!s.commodityData) { s.commodityData = [] }
        s.commodityData.forEach(m => {
          m.commodityRound = this.allRound
          this.selectedMiddleData.push(m)
        })
      })
      this.$forceUpdate()
    },
    /**
    * 清空失效商品
    * @date: 2020/4/2
    */
    async emptyCommodity () {
      // 同步购物车数据库
      await this.$tkParse.put(`/classes/shoppingCart/${this.shoppingCartId}`, { data: this.shoppingCart }).catch(e => {
        this.$tkGlobal.toast.add('清空失效商品失败')
      })
      await this.refreshInit()
      this.invalidArr = [] // 清空页面定义数据
      this.$tkGlobal.toast.add('清空失效商品成功')
    },
    /**
    * 执行删除商品
    * @date: 2020/4/1
    */
    async deleteCommodity () {
      if (!this.selectedMiddleData.length) {
        return this.$tkGlobal.toast.add('您还没有选择要删除的商品')
      }
      try {
        this.status = 'waiting'
        this.deleteDisabled = true
        if (this.allRound) { // 全选则清空
          this.shoppingCart = []
          if (this.invalidArr.length) {
            await this.$tkParse.put(`/classes/shoppingCart/${this.shoppingCartId}`, { data: this.shoppingCartInvalid }).catch(e => {
              throw this.$tkGlobal.toast.add('删除商品失败')
            })
          } else {
            await this.$tkParse.delete(`/classes/shoppingCart/${this.shoppingCartId}`).catch(e => {
              throw this.$tkGlobal.toast.add('删除商品失败')
            })
          }
          this.$tkGlobal.toast.add('删除商品成功')
          await this.refreshInit()
          await this.$tkHelper.sleep(500)
          this.selectedProductsData = []
          this.deleteDisabled = false
          this.toggleEditor = false
          this.status = false
          this.$forceUpdate()
          return
        }
        let copyArr = this.$tkHelper.deepClone(this.shoppingCart)
        for (let i = this.selectedMiddleData.length - 1; i >= 0; i--) {
          let s = this.selectedMiddleData[i]
          let findMIndex = copyArr[s.sIndex].commodityData.findIndex(l => {
            return l.mIndex === s.mIndex
          })
          if (findMIndex !== -1) { copyArr[s.sIndex].commodityData.splice(findMIndex, 1) }
          let findSIndex = copyArr.findIndex(n => {
            return n.sIndex === s.sIndex
          })
          if (findSIndex !== -1 && !copyArr[s.sIndex].commodityData.length) {
            copyArr.splice(findSIndex, 1)
          }
        }
        if (this.invalidArr.length) {
          copyArr.forEach(s => {
            let index = this.shoppingCartInvalid.findIndex(m => { return m.merchants.objectId === s.merchants.objectId })
            if (index !== -1) {
              s.commodityData = [...s.commodityData, ...this.shoppingCartInvalid[index].commodityData]
            }
          })
        }
        this.shoppingCart = copyArr
        await this.$tkParse.put(`/classes/shoppingCart/${this.shoppingCartId}`, { data: copyArr }).catch(e => {
          throw this.$tkGlobal.toast.add('删除商品失败')
        })
        this.$tkGlobal.toast.add('删除商品成功')
        await this.refreshInit()
        await this.$tkHelper.sleep(500)
        this.selectedProductsData = []
        this.deleteDisabled = false
        this.toggleEditor = false
        this.status = false
        this.$forceUpdate()
      } catch (e) {
        this.selectedProductsData = []
        this.deleteDisabled = false
        this.toggleEditor = false
        this.status = false
      }
    },
    /**
    * 分开结算按钮
    * @date: 2020/4/30
    */
    settlementSingle (s) {
      this.$store.commit('setSelectedData', [s])
      this.$push({ path: '/order/orderConfirmation', query: { type: 'shoppingCar', id: this.shoppingCartId } })
    },
    /**
    * 去订单确认页面
    * @date: 2020/4/28
    */
    settlementOrder () {
      if (!this.selectedProductsData.length) { return this.$tkGlobal.toast.add('您还没有选择要结算的商品') }
      if (this.selectedProductsData.length > 1) {
        this.selectedShow = true
        return
      }
      this.$store.commit('setSelectedData', this.selectedProductsData)
      this.$push({ path: '/order/orderConfirmation', query: { type: 'shoppingCar', id: this.shoppingCartId } })
    }
  }
}
</script>

<style scoped lang="scss">
  /*头部样式*/
  .header-editor {
    width: 60px;
    height: 30px;
    line-height: 30px;
  }
  .shopping-cart-bg {
    background-repeat: no-repeat;
    min-height: 500px;
    background-size: 100% 343px !important;
    // background-attachment: fixed !important;
  }
  /*后台数据渲染样式*/
  .content-box {
    padding-top: 70px;
    /*background-position: center center;*/
    /*图片样式*/
    .commodity-style-image {
      width: 85px;
      height: 85px;
      border-radius: 5px;
      overflow: hidden;
      position: relative;
      .commodity-style-image-invalid {
        position: absolute;
        bottom: 0;
        left: 0;
        border-radius: 5px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        line-height: 20px;
        width: 100%;
        height: 20px;
        background: rgba(0, 0, 0, 0.2);
      }
    }
    /*计数样式*/
    .selected-style-count {
      width: 100px;
      height: 29px;
      border: 2px solid rgba(245, 245, 245, 1);
      border-radius: 15px;
      .selected-style-count-left {
        width: 40px;
        text-align: center;
        line-height: 23px;
      }
      .selected-style-count-center {
        width: 40px;
        text-align: center;
        line-height: 25px;
        font-size: 14px;
        border-right: 2px solid rgba(245, 245, 245, 1);
        border-left: 2px solid rgba(245, 245, 245, 1);
      }
      .selected-style-count-right {
        width: 40px;
        text-align: center;
        line-height: 22px;
      }
    }
    /*失效商品样式*/
    .selected-style-filter {
      -webkit-filter: grayscale(100%); /* Chrome, Safari, Opera */
      filter: grayscale(100%);
    }
  }
  /*价格样式*/
  .commodity-style-price {
    color: rgba(250, 51, 51, 1);
  }
  /*底部样式*/
  .shopping-footer {
    min-height: 50px;
    background: #fff;
    padding: 10px 12px;
    .card-title {
      height: 20%;
    }
    .settlement-delete {
      width: 60px;
      height: 30px;
      text-align: center;
      line-height: 30px;
    }
  }
  .settlement-btn {
    margin: 0;
    line-height: 24px;
    height: 24px !important;
    min-width: 60px !important;
  }
  /*弹框样式*/
  .selected-card {
    height: 60%;
    width: 100vw;
    padding: 12px 0;
    background: #F5F5F5;
    border-radius: 10px 10px 0 0;
    .cover-scroll-y {
      overflow-y: auto;
      height: 95%;
      overflow-x: hidden;
      ::v-deep .class-card-style {
        padding-left: 0 !important;
        padding-top: 0 !important;
      }
      ::v-deep .font-bold {
        font-weight: normal !important;
      }
    }
    .cover-scroll-x {
      overflow-x: auto;
      overflow-y: hidden;
    }
    .cover-image {
      width: 105px;
      height: 105px;
      background: #f5f5f5;
    }
  }
</style>
